export default __webpack_public_path__ + "static/media/dust_scratches.3a1926a3.png";